<script setup lang="ts">
import { OptionMain } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  option: OptionMain
  checkedOption: number
  disableAdd: boolean
}>()

defineEmits(['update:checkedOption'])

const checked = useVModel(props, 'checkedOption', (v: number) => !!v)

const onUpdateChecked = ($ev: boolean) => {
  const checkedAsNumber = $ev ? 1 : 0
  checked.value = checkedAsNumber
}
</script>

<template>
  <div data-test="quantity-selector-row" class="my-4 flex flex-row items-center gap-2">
    <div class="relative h-12 w-12 min-w-[3rem] rounded-[50%] bg-mcd-secondary">
      <ImageResolver
        class="absolute left-1/2 top-1/2 h-9 w-auto -translate-x-1/2 -translate-y-1/2"
        :url="option.imageUrl"
        :alt="option.name"
      />
    </div>
    <p class="line-clamp-2 flex-1 text-sm font-bold">
      {{ option.name }}
    </p>
    <Checkbox
      v-model:checked="checked"
      :disable-add="disableAdd"
      :name="option.name"
      @update:checked="onUpdateChecked"
    />
  </div>
</template>
